import React, { useState, useEffect } from "react";
import EmailNotificationAction from "../../Actions/EmailNotificationAction";
import emailStore from "../../Stores/EmailNotificationStore";
import EmailConstants from "../../Constants/EmailNotificationConstants";
import { toast } from "react-toastify";
import commonUtils from "../../helpers/commonUtils";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import { _validateField } from "../ControlValidation/ValidateField";

export default function EmailReplace({ getDistributionGroup }) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [currentEmail, setCurrentEmail] = useState("");
  const [NewEmail, setNewEmail] = useState("");
  const [flag, setFlag] = useState({ currentEmail: false, newEmail: false });
  const [errorMsg, setErrorMsg] = useState({
    currentEmail: "",
    newEmail: "",
  });

  function handleSubmit(event) {
    event.preventDefault();
    const payload = {
      OldEmail: currentEmail.trim(),
      NewEmail: NewEmail.trim(),
    };
    setGlobalSpinner(true);
    EmailNotificationAction.replaceEmail(payload);
  }
  /* <>--------------------------------------------------------------------Replace Email Start----------------------------------------------------------<> */
  useEffect(() => {
    function getEmailReplaceSuccess() {
      var res = emailStore.getResult();
      toast.success(localization.replaceSuccess);
      setCurrentEmail("");
      setNewEmail("");
      commonUtils.hideModalPopUp("addreplaceEmailModalClose");
      getDistributionGroup();
    }

    function getEmailReplaceFailure() {
      var res = emailStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    emailStore.addChangeListener(
      EmailConstants.REPLACE_EMAIL_SUCCESS,
      getEmailReplaceSuccess
    );

    emailStore.addChangeListener(
      EmailConstants.REPLACE_EMAIL_FAILURE,
      getEmailReplaceFailure
    );
    return () => {
      emailStore.removeChangeListener(
        EmailConstants.REPLACE_EMAIL_SUCCESS,
        getEmailReplaceSuccess
      );

      emailStore.removeChangeListener(
        EmailConstants.REPLACE_EMAIL_FAILURE,
        getEmailReplaceFailure
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------Replace Email End----------------------------------------------------------<> */

  function handlePopOverClose() {
    setNewEmail("");
    setCurrentEmail("");
    setErrorMsg({
      currentEmail: "",
      newEmail: "",
    });
    setFlag({ currentEmail: false, newEmail: false });
  }

  function validateEmail(e) {
    const { value, name } = e.target;
    if (value === "") {
      return;
    }
    if (
      name === "newEmail" &&
      currentEmail.toLowerCase() === value.toLowerCase()
    ) {
      setErrorMsg({
        ...errorMsg,
        [name]: localization.errorMsg,
      });
      if (!flag[name]) {
        setFlag({ ...flag, [name]: true });
      }
    } else {
      if (!_validateField.EmailValidation(value)) {
        if (!flag[name]) {
          setFlag({ ...flag, [name]: true });
        }
        setErrorMsg({
          ...errorMsg,
          [name]: localization.enterValidEmail,
        });
      } else if (flag[name]) {
        setErrorMsg({ ...errorMsg, [name]: "" });
        setFlag({ ...flag, [name]: false });
      }
    }
  }
  return (
    <div
      className="modal fade"
      id="addreplaceEmail"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addreplaceEmail"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="emailReplacer">
              {localization.replaceHeader}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addreplaceEmailModalClose"
              onClick={handlePopOverClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form id="emailreplce" autoComplete="off" onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="currentEmail">
                  {localization.currentEmail}
                </label>
                <input
                  className={`form-control ${
                    flag.currentEmail ? "is-invalid" : ""
                  }`}
                  type="email"
                  id="currentEmail"
                  name="currentEmail"
                  required
                  onBlur={validateEmail}
                  value={currentEmail}
                  onChange={(e) => {
                    if (currentEmail !== "") {
                      setCurrentEmail(e.target.value);
                    } else {
                      setCurrentEmail(e.target.value.trim());
                    }
                    if (flag.currentEmail) validateEmail(e);
                  }}
                />{" "}
                {flag.currentEmail && (
                  <div className="invalid-feedback">
                    {errorMsg.currentEmail}
                  </div>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="newEmail">{localization.newEmail}</label>
                <input
                  className={`form-control ${
                    flag.newEmail ? "is-invalid" : ""
                  }`}
                  type="email"
                  id="newEmail"
                  name="newEmail"
                  required
                  value={NewEmail}
                  onBlur={validateEmail}
                  onChange={(e) => {
                    if (NewEmail !== "") {
                      setNewEmail(e.target.value);
                    } else {
                      setNewEmail(e.target.value.trim());
                    }
                    if (flag.newEmail) validateEmail(e);
                  }}
                />
                {flag.newEmail && (
                  <div className="invalid-feedback">{errorMsg.newEmail}</div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                  disabled={flag.currentEmail || flag.newEmail}
                >
                  {localization.replace}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
